<template>
  <div
    class="cluster"
    :style="{
      '--gutter': gutter,
      '--cluster-horizontal-alignment': horizontalAlignment,
      '--cluster-vertical-alignment': verticalAlignment,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    gutter: {
      type: String,
      required: false,
      default: "",
    },
    horizontalAlignment: {
      type: String,
      required: false,
      default: "",
    },
    verticalAlignment: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup() {},
};
</script>

<style lang="scss">
.cluster {
  display: flex;
  flex-wrap: wrap;
  gap: var(
    --gutter,
    var(--global-space)
  ); // Set a space for gap with default size as a fallback
  justify-content: var(--cluster-horizontal-alignment, flex-start);
  align-items: var(--cluster-vertical-alignment, center);

  /* Exceptions */

  // Remove gutter
  &[data-gutter="none"] {
    --gutter: 0px;
  }
}
</style>
